(function() {
  class FeaturedCollectionTabs {
    constructor(container) {
      this.root = container;
      this.tabs = this.root.querySelectorAll('.fc-tabs__tab');
      this.panels = this.root.querySelectorAll('[role="tabpanel"]');
      this.nav = this.root.querySelector('.fc-tabs__nav');
      this.resizeTimer = null;

      if (!this.root || !this.tabs.length) return;

      this.init();
    }

    init() {
      // Check for tabs scroll setting from data attribute
      this.tabsScroll = this.root.dataset.tabsScroll === 'true';

      this.activate(this.tabs[0].getAttribute('data-target'));

      this.tabs.forEach(t => {
        t.addEventListener('click', () => {
          this.activate(t.getAttribute('data-target'));
        });
        t.addEventListener('keydown', (e) => this.handleKeydown(e, t));
      });

      this.ensureScrollable();
      window.addEventListener('resize', () => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => this.ensureScrollable(), 100);
      }, {
        passive: true
      });
    }

    ensureScrollable() {
      try {
        if (!this.nav) return;
        const need = this.nav.scrollWidth > this.nav.clientWidth;
        this.nav.classList.toggle('is-scroll', need || this.tabsScroll);
      } catch (e) {}
    }

    scrollTabIntoView(el) {
      try {
        if (!el || !this.nav) return;
        el.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      } catch (e) {}
    }

    shuffleAndLimit(panel) {
      try {
        const ul = panel.querySelector('ul[data-limit]');
        if (!ul) return;
        const limit = parseInt(ul.getAttribute('data-limit') || '0', 10);
        if (!limit) return;
        const mode = (ul.getAttribute('data-random') || 'once').toString();
        const items = Array.from(ul.children);
        let chosen = Array.from(ul.querySelectorAll('.is-chosen'));
        const initial = chosen.length === 0;

        if (initial) {
          // First run: pick a random subset and mark as chosen
          const shuffled = items.slice().sort(() => Math.random() - 0.5);
          chosen = shuffled.slice(0, limit);
          items.forEach(li => li.style.display = 'none');
          chosen.forEach(li => {
            li.classList.add('is-chosen');
            li.style.display = '';
          });
          panel.setAttribute('data-shuffled', 'true');
          return;
        }

        // Subsequent runs: reorder chosen only if mode indicates always
        const always = (mode === 'true' || mode === 'always');
        if (!always) return;

        const reshuffled = chosen.slice().sort(() => Math.random() - 0.5);
        reshuffled.forEach(li => ul.appendChild(li));
        // ensure visibility state remains consistent
        items.forEach(li => li.style.display = li.classList.contains('is-chosen') ? '' : 'none');
      } catch (e) {}
    }

    activate(id) {
      this.tabs.forEach(t => {
        const on = (t.getAttribute('data-target') === id);
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });

      this.panels.forEach(p => {
        const on = (p.id === id);
        p.classList.toggle('is-active', on);
        p.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (on) this.shuffleAndLimit(p);
      });

      const active = this.root.querySelector('.fc-tabs__tab.is-active');
      this.scrollTabIntoView(active);
    }

    handleKeydown(e, t) {
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        const arr = Array.from(this.tabs);
        const i = arr.indexOf(t);
        const next = e.key === 'ArrowRight' ? arr[(i + 1) % arr.length] : arr[(i - 1 + arr.length) % arr.length];
        next.focus();
        this.activate(next.getAttribute('data-target'));
      }
    }
  }

  class FeaturedCollectionPagination {
    constructor(container) {
      this.container = container;
      this.init();
    }

    init() {
      this.button = this.container.querySelector('.fc-load-more-btn');
      if (!this.button) return;
      this.list = this.container.querySelector('[role="list"]'); // Matches slider/grid ul
      
      // Remove existing listeners to avoid duplicates if re-init
      const newBtn = this.button.cloneNode(true);
      this.button.parentNode.replaceChild(newBtn, this.button);
      this.button = newBtn;
      
      this.button.addEventListener('click', (e) => {
        e.preventDefault();
        this.loadMore();
      });
    }

    async loadMore() {
      const url = this.button.dataset.url;
      if (!url) return;
      
      this.button.classList.add('loading');
      this.button.setAttribute('disabled', 'true');
      const originalText = this.button.textContent;
      this.button.textContent = 'Loading...';

      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error('Network response was not ok');
        const text = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, 'text/html');
        
        // Find list in response. We expect the same ID structure
        // The ID of the list is Slider-{{ section.id }}
        const listId = this.list.id;
        const newItems = doc.querySelectorAll(`#${listId} > li`);
        
        if (newItems.length > 0) {
           newItems.forEach(item => {
             // If we are in a slider, we might need to be careful. 
             // But usually for "Load More" we assume grid flow.
             this.list.appendChild(item);
           });
        }

        // Check for next page
        const newBtn = doc.querySelector('.fc-load-more-btn');
        if (newBtn && newBtn.dataset.url) {
          this.button.dataset.url = newBtn.dataset.url;
          this.button.classList.remove('loading');
          this.button.removeAttribute('disabled');
          this.button.textContent = originalText;
        } else {
          this.button.remove();
        }
      } catch (e) {
        console.error('Error loading more products:', e);
        this.button.classList.remove('loading');
        this.button.removeAttribute('disabled');
        this.button.textContent = originalText;
      }
    }
  }

  // Initialize
  document.addEventListener('DOMContentLoaded', () => {
    const init = () => {
       document.querySelectorAll('[id^="collection-"]').forEach(el => new FeaturedCollectionTabs(el));
       // We initialize pagination on the section container
       document.querySelectorAll('.collection-section').forEach(el => new FeaturedCollectionPagination(el)); 
    };
    init();
    // Re-init on Shopify section re-render (for editor)
    document.addEventListener('shopify:section:load', init);
  });
})();
